import type { VariantProps } from "tailwind-variants";

import type { AcuityScore } from "@/core/types";
import { Badge2 } from "@/ui2/atoms/Badge";
import type { badgeStyles } from "@/ui2/atoms/Badge";
import { cn } from "@/lib/helpers/cn";

type AcuityScoreBadgeProps = {
  acuityScore: AcuityScore;
  className?: string;
  isLabelled?: boolean;
};

export function AcuityScoreBadge({
  acuityScore,
  className,
  isLabelled = true,
}: AcuityScoreBadgeProps) {
  const { label, variant: badgeVariant } = ACUITY_SCORE_TO_BADGE[acuityScore] || {};

  if (!acuityScore)
    return (
      <Badge2 className={cn("tw:normal-case", className)} size="md" variant="neutral">
        Unspecified
      </Badge2>
    );

  return (
    <Badge2 className={cn("tw:normal-case", className)} size="md" variant={badgeVariant}>
      {isLabelled ? `${acuityScore} ${label}` : `${acuityScore}`}
    </Badge2>
  );
}

type Variant = VariantProps<typeof badgeStyles>["variant"];

const ACUITY_SCORE_TO_BADGE: Record<AcuityScore, { label: string; variant: Variant }> = {
  1: {
    label: "Mild",
    variant: "success",
  },
  2: {
    label: "Moderate",
    variant: "warning",
  },
  3: {
    label: "Intense",
    variant: "orange",
  },
  4: {
    label: "Severe",
    variant: "error",
  },
} as const;
